<lui-drawer-container>
  <lui-drawer #drawer class="w-100 mw-lg" mode="cover" position="end">
    <div
      class="hstack justify-content-between bg-black zone-dark ps-5 pe-2 py-2 position-sticky top-0 z-1"
    >
      <div class="hstack">
        <lui-avatar size="56px" color="primary">
          <mat-icon svgIcon="status"></mat-icon>
        </lui-avatar>
        <h3 class="ms-1">Developer options</h3>
      </div>

      <button luiIconButton size="lg" (click)="drawer.close()">
        <mat-icon svgIcon="close_light"></mat-icon>
      </button>
    </div>

    <div class="vstack p-5">
      <formly-form #formly [fields]="fields"></formly-form>
    </div>

    <div class="bg-grayDark zone-dark p-2 mt-auto position-sticky bottom-0">
      <div class="justify-content-end hstack gap-1">
        <button luiButton (click)="onSubmit(formly.form.value)">Apply</button>
      </div>
    </div>
  </lui-drawer>
</lui-drawer-container>

<button luiCab size="lg" (click)="drawer.toggle(true)" class="trigger">
  <mat-icon svgIcon="status"></mat-icon>
</button>
